import { toast } from "sonner";
import { PauseCircle, Play, Trash2, ArrowLeftRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";
import { isOffline } from "@/lib/offline";

const CAJAS = ["Caja 01", "Caja 02", "Caja 03"];

export default function HoldSalesDrawer({ open, onClose, holds, onRestore, onRefresh }) {
  async function eliminar(h) {
    try {
      if (!h.local) await api.delete(`/ventas-espera/${h.id}`);
      else {
        const local = JSON.parse(localStorage.getItem("rubipos_holds") || "[]").filter((x) => x.id !== h.id);
        localStorage.setItem("rubipos_holds", JSON.stringify(local));
      }
      onRefresh();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }

  async function transferir(h, caja) {
    try {
      await api.post(`/ventas-espera/${h.id}/transferir`, { caja });
      toast.success(`Venta transferida a ${caja}`);
      onRefresh();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="hold-sales-drawer">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold flex items-center gap-2">
            <PauseCircle className="w-5 h-5 text-brand-amber" /> Ventas en espera ({holds.length})
          </DialogTitle>
        </DialogHeader>
        {holds.length === 0 && <p className="text-sm text-brand-muted py-6 text-center">No hay ventas en espera.</p>}
        <div className="space-y-2 max-h-[50vh] overflow-y-auto scrollbar-thin">
          {holds.map((h) => (
            <div key={h.id} className="surface-card p-3 animate-pop" data-testid={`hold-item-${h.id}`}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-semibold text-brand-ink">{h.items?.length || 0} producto(s) · {h.caja}</div>
                  <div className="text-xs text-brand-muted">{h.cajero_nombre || "Local"} · {new Date(h.created_at).toLocaleString("es-MX")}</div>
                  {h.nota && <div className="text-xs italic text-brand-muted mt-0.5">“{h.nota}”</div>}
                </div>
                <div className="flex items-center gap-1">
                  <button data-testid={`hold-restore-${h.id}`} onClick={() => { onRestore(h); onClose(); }} className="p-2 rounded-lg bg-brand-amber text-brand-ink hover:bg-brand-amber-hover active:scale-95 transition-[background-color,transform] duration-150" title="Retomar venta">
                    <Play className="w-4 h-4" />
                  </button>
                  {!h.local && !isOffline() && (
                    <select data-testid={`hold-transfer-${h.id}`} value={h.caja} onChange={(e) => transferir(h, e.target.value)} className="field h-8 w-auto text-xs px-1" title="Transferir a otra caja">
                      {CAJAS.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                  )}
                  <button data-testid={`hold-delete-${h.id}`} onClick={() => eliminar(h)} className="p-2 rounded-lg text-brand-muted hover:text-rose-600 hover:bg-rose-50 transition-colors duration-150" title="Descartar">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-2 text-xs text-brand-muted">
          <ArrowLeftRight className="w-3.5 h-3.5" /> Las ventas en espera pueden transferirse entre cajas.
        </div>
      </DialogContent>
    </Dialog>
  );
}
